module.exports = __webpack_public_path__ + "img/全球采购与物流.12b2087b.png";